"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var hex_1 = require("../utils/hex");
var tools_1 = require("../utils/tools");
var NAME = 'color';
var black = 'rgba(0, 0, 0, 1)';
var Color = /** @class */ (function (_super) {
    __extends(Color, _super);
    function Color() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'span'; };
        _this.attrs = {
            color: {
                default: "" + black
            }
        };
        _this.parseDOM = [
            {
                style: 'color',
                getAttrs: getAttrs
            },
            {
                tag: '*[color]',
                getAttrs: function (dom) { return getAttrs(dom.getAttribute('color')); }
            }
        ];
        _this.toDOM = function (node) { return ['span', { style: "color: " + node.attrs.color }, 0]; };
        return _this;
    }
    return Color;
}(core_utilities_1.Inline));
exports.Color = Color;
function getAttrs(style) {
    var color = hex_1.toRgba(style);
    if (color) {
        return {
            color: color
        };
    }
    return false;
}
exports.getAttrs = getAttrs;
var ColorController = /** @class */ (function (_super) {
    __extends(ColorController, _super);
    function ColorController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'color';
        _this.defaultColor = black;
        _this.getAttrs = function (color) {
            var rgba = "rgba(" + color.r + ", " + color.g + ", " + color.b + ", " + color.a + ")";
            return {
                color: "" + rgba
            };
        };
        _this.getValue = function (attrs) {
            return attrs.color;
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        _this.toolbar = {
            className: 'color',
            tooltip: 'color'
        };
        return _this;
    }
    return ColorController;
}(core_utilities_1.SylController));
exports.ColorController = ColorController;
var ColorPlugin = /** @class */ (function (_super) {
    __extends(ColorPlugin, _super);
    function ColorPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Controller = ColorController;
        _this.Schema = Color;
        return _this;
    }
    return ColorPlugin;
}(core_utilities_1.SylPlugin));
exports.ColorPlugin = ColorPlugin;
//# sourceMappingURL=color.js.map